import { useTranslation } from 'react-i18next'
import { BreadCrumb } from 'components/BreadCrumb/BreadCrumb'
import { Component } from '@cms-max/medicare-api-sdk/dist/api'

export function BackToEasyPayBreadcrumb () {
  const { t } = useTranslation('easyPayCommon')

  return (
    <BreadCrumb
      // TODO: This should probably be unique but this nav does only contain the one link, so this should be alright
      navAriaLabel={t('backToMyMedicareEasyPay')}
      backButtonText={t('backToMyMedicareEasyPay')}
      backButtonLink="/premiums/easy-pay"
      width="wide"
      siteActivityProps={{
        core: {
          component: Component.EasyPay,
          elementId: `premiums_backtoeasypay_click`,
          coreClickData: {
            linkText: t('backToMyMedicareEasyPay'),
            linkUrl: '/premiums/easy-pay'
          }
        }
      }}
    />
  )
}
